import { BaseFieldModel } from "../base-field.model";

export interface ContactFieldModel extends BaseFieldModel {
  name: string;
}

